import { Link } from "react-router-dom";
import { Face } from "@/lib/brand";
import { useSeo } from "@/hooks/useSite";

export default function NotFound() {
  useSeo("Page not found", null);
  return (
    <section className="mx-auto flex max-w-xl flex-col items-start px-5 py-28 sm:px-8" data-testid="not-found-page">
      <Face name="blink" className="h-16 w-16" />
      <h1 className="mt-8 text-4xl font-semibold tracking-tight">This page took a gentle pass.</h1>
      <p className="cw-soft mt-4 text-lg">The link may be old, or the page moved.</p>
      <Link to="/" className="mt-10 inline-flex h-12 items-center rounded-full bg-primary px-6 font-medium text-white transition-colors cw-ease hover:bg-primary/90" data-testid="not-found-home-link">
        Back home
      </Link>
    </section>
  );
}
